
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Star } from "lucide-react";
import { format } from "date-fns";

interface Feedback {
  id: string;
  rating: number;
  feedback_text: string | null;
  created_at: string;
}

interface SessionFeedbackDisplayProps {
  feedback: Feedback;
  sessionType: string;
}

const SessionFeedbackDisplay = ({ feedback, sessionType }: SessionFeedbackDisplayProps) => {
  return (
    <Card className="mt-4 bg-green-50 border-green-200">
      <CardHeader>
        <CardTitle className="text-lg text-green-800">Your Feedback</CardTitle>
        <p className="text-sm text-green-600">
          Submitted on {format(new Date(feedback.created_at), "MMM d, yyyy")}
        </p>
      </CardHeader>
      <CardContent className="space-y-3">
        <div>
          <label className="text-sm font-medium text-green-800 mb-1 block">Rating</label>
          <div className="flex gap-1">
            {[1, 2, 3, 4, 5].map((star) => (
              <Star
                key={star}
                className={`h-5 w-5 ${
                  star <= feedback.rating
                    ? 'fill-yellow-400 text-yellow-400'
                    : 'text-muted-foreground'
                }`}
              />
            ))}
          </div>
        </div>

        {feedback.feedback_text && (
          <div>
            <label className="text-sm font-medium text-green-800 mb-1 block">Your Comments</label>
            <p className="text-sm text-green-700 bg-white p-3 rounded border border-green-200">
              {feedback.feedback_text}
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default SessionFeedbackDisplay;
